/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type BillStateEnum = 1 | 2 | 3;

export const BillStateEnum = {
    NUMBER_1: 1 as BillStateEnum,
    NUMBER_2: 2 as BillStateEnum,
    NUMBER_3: 3 as BillStateEnum
};
